import { SvgIcon } from "@mui/material";
import { ReactComponent as PeopleOutlined } from '../icons/ic_people.svg';

function PeopleOutlinedIcon(props){
    return  <SvgIcon
    {...props}
    component={PeopleOutlined}
    inheritViewBox
  />
}

export default PeopleOutlinedIcon